import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowRightIcon, CheckCheckIcon} from '../icons';
import {FINAL_CTA} from './content';
import {LandingCta as LandingCtaLinks} from './cta';
import {GarmentTile} from './visuals';

/**
 * Финальный decision region: одна primary-кнопка, вторичный вход и условия старта.
 *
 * Второй и последний пик страницы: заголовок берёт масштаб секционного, полоса
 * вещей слева отвечает hero — страница закрывается тем же образом, которым
 * открылась.
 */
const LandingCta: React.FC<{cta: LandingCtaLinks}> = ({cta}) => (
    <section
        className="rounded-3xl border border-brand-100 dark:border-brand-500/20 bg-brand-50 dark:bg-brand-500/10 overflow-hidden"
        aria-labelledby="landing-cta-title"
    >
        <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] items-center">
            <div className="hidden lg:grid grid-cols-4 gap-2 p-8" aria-hidden="true">
                <GarmentTile kind="outer" className="aspect-[3/4]"/>
                <GarmentTile kind="top" className="aspect-[3/4]"/>
                <GarmentTile kind="bottom" className="aspect-[3/4]"/>
                <GarmentTile kind="bag" className="aspect-[3/4]"/>
            </div>

            <div className="p-6 sm:p-12">
                <h2
                    id="landing-cta-title"
                    className="text-3xl sm:text-[2.5rem] font-bold leading-[1.06] tracking-[-0.03em]
                               text-ink-900 dark:text-ink-50 text-balance"
                >
                    {FINAL_CTA.title}
                </h2>
                <p className="mt-5 text-base sm:text-lg leading-7 text-ink-600 dark:text-ink-200 max-w-[46ch]">
                    {FINAL_CTA.text}
                </p>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                    <Link to={cta.finalPrimary.href} className="btn-accent h-12 text-[15px]">
                        {cta.finalPrimary.label}
                        <ArrowRightIcon className="w-4 h-4"/>
                    </Link>
                    {cta.login && (
                        <Link to={cta.login.href} className="btn-secondary h-12 text-[15px]">{cta.login.label}</Link>
                    )}
                </div>

                <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-2">
                    {FINAL_CTA.notes.map(note => (
                        <li key={note} className="flex items-center gap-2 text-xs text-ink-600 dark:text-ink-300">
                            <CheckCheckIcon className="w-4 h-4 text-brand-600 dark:text-brand-400"/>
                            {note}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);

export default LandingCta;
